import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";

const useStyles = makeStyles((theme) => ({
  cssCard: {
    textAlign: "center",
  },
}));

const stylesCss = {
  root: {
    "& .MuiStepIcon-root.Mui-active": { color: "red" },
    "& .MuiStepIcon-root.Mui-completed": { color: "#FF0000" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ffcdd2" },
  },
  card: {
    textAlign: "center",
  },
  btnBuscarRegresar: {
    backgroundColor: "red",
    borderRadius: "13px",
    height: "60px",
    padding: "15px 30px 15px 30px",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      opacity: [0.9, 0.8, 0.7],
      color: "black",
    },
  },
  btnNoEmpresa: {
    backgroundColor: "rgb(121, 117, 117)",
    borderRadius: "13px",
    textAlign: "center",
    width: "200px",
    padding: "15px 30px 15px 30px",
  },
  gridBtnRegresar: {
    textAlign: "right",
  },
  gridBtnContinuar: {
    textAlign: "left",
  },
  radioGroup: {
    alignItems: "center",
  },
  radio: {
    color: "#FF0000",
    "&.Mui-checked": {
      color: "#FF0000",
    },
  },
};

const Tittle = styled("p")(({ theme }) => ({
  color: "#FF0000",
  padding: "35px 0px 0px 0px",
  fontWeight: "bold",
  fontSize: "2.5rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));
const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "8px",
  },
}));
const Column = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  //   minHeight: "550px",
  padding: "15px",
  width: "100%",
  maxWidth: "550px",
  //   background: "#F3F3F3",
  [theme.breakpoints.down("sm")]: {
    // minHeight: "500px",
  },
}));
const ButtonUpload = styled("button")(({ theme }) => ({
  // marginTop: "35px",
  width: "100%",
  backgroundColor: "#ffe3e3",
  textAlign: "center",
  padding: "15px",
  borderRadius: "15px",
  borderWidth: "1px",
  color: "black",
  minHeight: "82.5px",
  // backgroundColor: "#FF0000",
  "&:hover:enabled": {
    backgroundColor: "#FF0000",
    opacity: [0.9, 0.8, 0.7],
    color: "white",
  },
  "&:disabled": {
    backgroundColor: "#E9E9E9",
    opacity: [0.9, 0.8, 0.7],
    color: "white",
  },
}));
const CssNativeSelect = styled(NativeSelect)({
  "& .MuiNativeSelect-select": {
    textAlign: "center",
    paddingTop: "12px",
  },
});
const OptionSelect = styled("option")(({ theme }) => ({
  color: "black",
  background: "white",
  display: "flex",
  whiteSpace: "pre",
  minHeight: "20px",
  textAlign: "center",
  fontSize: "18px",
}));

export {
  Tittle,
  Container,
  Column,
  CssNativeSelect,
  OptionSelect,
  ButtonUpload,
};

export default stylesCss;
export { useStyles };
